import { defineMessages } from "react-intl";

export const scope = "components.HisotryDetailsInterest";

export const messages = defineMessages({
      copySuccess: {
        id: `${scope}.copySuccess`,
        defaultMessage: "Copiado con exito",
      },
      statusInProgress: {
        id: `${scope}.statusInProgress`,
        defaultMessage: "Pendiente",
      },
      statusFailed: {
        id: `${scope}.statusFailed`,
        defaultMessage: "Falló",
      },
      statusOk: {
        id: `${scope}.statusOk`,
        defaultMessage: "Finalizado",
      },
      fee: {
        id: `${scope}.fee`,
        defaultMessage: "Comisión",
      },
      status: {
        id: `${scope}.status`,
        defaultMessage: "Estado",
      },
      earned: {
        id: `${scope}.earned`,
        defaultMessage: "Generado",
      },
      movementId: {
        id: `${scope}.movementId`,
        defaultMessage: "Id de movimiento",
      },
      approved: {
        id: `${scope}.approved`,
        defaultMessage: "Aprobado",
      },
      rejected: {
        id: `${scope}.rejected`,
        defaultMessage: "Rechazado",
      },
      date: {
        id: `${scope}.date`,
        defaultMessage: "Fecha",
      },
});
